// ViewModalSchedulerSection.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import SelectInput from 'components/selectinput/SelectInput';

const SLOT_INCREMENT_OPTIONS = [
    { value: '15', label: '15 minutes' },
    { value: '30', label: '30 minutes' },
    { value: '60', label: '60 minutes' },
];

/**
 * ViewModalSchedulerSection
 *
 * Renders Scheduler-specific configuration controls.
 *
 * @returns {ReactNode} The rendered scheduler settings block.
 */
const ViewModalSchedulerSection = ({
    isVisible,
    scheduledType,
    setScheduledType,
    scheduledTypeOptions,
    scheduledField,
    setScheduledField,
    scheduledFieldOptions,
    slotIncrementMinutes,
    setSlotIncrementMinutes,
}) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    if (!isVisible) return null;
    // ----- RENDER ----- //

    return (
        <ModalField>

            <ModalLabel label="Scheduler" />
            <ModalHint hint="Choose the scheduled type, time field, and slot size for this schedule." />

            <div className="view-modal-rows">
                <div
                  className="view-modal-row"
                  style={{
                    gridTemplateColumns: '1fr',
                  }}
                >
                    <SelectInput
                      style={{
                        fontSize: '12px',
                      }}
                      value={scheduledType || ''}
                      options={scheduledTypeOptions}
                      placeholder="Select scheduled type..."
                      onChange={(event) => setScheduledType(event.target.value)}
                    />
                </div>

                <div
                  className="view-modal-row"
                  style={{
                    gridTemplateColumns: '1fr',
                  }}
                >
                    <SelectInput
                      style={{
                        fontSize: '12px',
                      }}
                      value={scheduledField || ''}
                      disabled={!scheduledType}
                      options={scheduledFieldOptions}
                      placeholder="Select time field..."
                      onChange={(event) => setScheduledField(event.target.value)}
                    />
                </div>

                <div
                  className="view-modal-row"
                  style={{
                    gridTemplateColumns: '1fr',
                  }}
                >
                    <SelectInput
                      style={{
                        fontSize: '12px',
                      }}
                      value={slotIncrementMinutes || '15'}
                      options={SLOT_INCREMENT_OPTIONS}
                      onChange={(event) => setSlotIncrementMinutes(event.target.value)}
                    />
                </div>
            </div>

            {scheduledTypeOptions.length === 0 && (
                <div
                  className="view-modal-empty"
                  style={{
                    color: theme.foregroundMuted,
                  }}
                >
                    Add a node type with a date-time range field to configure Scheduler.
                </div>
            )}

            {scheduledType && scheduledFieldOptions.length === 0 && (
                <div
                  className="view-modal-empty"
                  style={{
                    color: theme.foregroundMuted,
                  }}
                >
                    The selected type does not have a date-time range field available for scheduling.
                </div>
            )}

        </ModalField>
    );
};

// Dev Tools
ViewModalSchedulerSection.displayName = 'ViewModalSchedulerSection';

export default ViewModalSchedulerSection;
